export default __webpack_public_path__ + "static/media/13.fb73a465.jpg";